<template>
  <div>
    <div>
      <div class="font-weight-bold">
        {{ $t('shop.reports.name') }}:
      </div>
      <BFormInput v-model="reportName" />
    </div>
    <hr class="mb-0">
    <div
      class="d-flex align-items-center py-2 group-row"
      @click="reportUnpaid = !reportUnpaid"
    >
      <Checkbox
        :value="reportUnpaid"
        :emit="false"
      />
      <span class="font-weight-bold">
        {{ $t('shop.showUnpaid') }}
      </span>
    </div>
    <div
      class="d-flex align-items-center py-2 group-row"
      @click="productsInColumns = !productsInColumns"
    >
      <Checkbox
        :value="productsInColumns"
        :emit="false"
      />
      <span class="font-weight-bold">
        {{ $t('shop.productsInColumns') }}
      </span>
    </div>

    <template v-if="productsInColumns">
      <div class="font-weight-bold mt-2">
        {{ $t('shop.reports.splitBy') }}
      </div>
      <div>
        <div
          v-for="s in catalogDetails.subCatalogs.filter(x => !x.subCatalogId.startsWith('#'))"
          :key="s.id"
          class="d-flex align-items-center group-row"
          @click="toggleSplitBy(s.subCatalogId)"
        >
          <Checkbox
            :value="splitBy.includes(s.subCatalogId)"
            :emit="false"
          />

          {{ s.name }}
        </div>
      </div>
    </template>

    <div class="font-weight-bold mt-2">
      {{ $t('shop.reports.filterGroups') }}:
    </div>
    <GroupSelect
      :group-codes.sync="groups"
      show-select-all
      allow-rule-based-select
    />

    <hr>
    <SwitchWithDescription
      :title="$t('shop.reports.send')"
      small
      class="mb-1"
      style="min-height: 44px; margin-top: 0"
      :value="emailEnabled"
      @switch="emailEnabled = !emailEnabled"
    />

    <div v-if="emailEnabled">
      <div class="font-weight-bold mt-3">
        {{ $t('shop.reports.emails') }} ({{ $t('shop.reports.lineSeparated') }}):
      </div>
      <BFormTextarea
        v-model="emails"
        :placeholder="$t('shop.reports.emailsInLines')"
        rows="3"
      />
      <DeliveryTimeSelect
        class="mt-2"
        month-delivery
        style="margin-left: -1rem; margin-right: -1rem"
        :hour.sync="hour"
        :skip-weekend.sync="skipWeekend"
        :day-offset.sync="dayOffset"
        :type.sync="emailScopeType"
      />
    </div>
  </div>
</template>

<script>
import GroupSelect from '@/components/payers/form/GroupSelect';
import SwitchWithDescription from '@/components/settings/SwitchWithDescription';
import { mapGetters } from 'vuex';
import DeliveryTimeSelect from '../DeliveryTimeSelect';

export default {
  props: {
    subscription: Object,
  },
  data: () => ({
    emails: '',
    groups: [],
    hour: '9:00',
    emailScopeType: 'day',
    skipWeekend: false,
    dayOffset: 0,
    reportUnpaid: false,
    productsInColumns: true,
    pending: false,
    sortBy: [],
    splitBy: [],
    reportName: '',
    emailEnabled: false,
  }),
  components: {
    SwitchWithDescription,
    DeliveryTimeSelect,
    GroupSelect,
  },
  computed: {
    ...mapGetters([
      'payee',
      'userGroups',
    ]),
    ...mapGetters('shop', [
      'singleOrderSchema',
      'catalogDetails',
    ]),
    config() {
      return {
        name: this.reportName,
        reportUnpaid: this.reportUnpaid,
        productsInColumns: this.productsInColumns,
        hour: this.hour,
        splitBy: this.productsInColumns ? this.splitBy : [],
        dayOffset: parseInt(this.dayOffset, 10),
        skipWeekend: this.skipWeekend,
        groups: this.groups,
        emailDisabled: !this.emailEnabled,
        emails: this.emails.split('\n')
          .filter((x) => x && x.includes('@'))
          .map((x) => x.trim()),
      };
    },
  },
  watch: {
    config(c) {
      this.$emit('update', c);
    },
  },
  methods: {
    toggleSplitBy(subCatalogId) {
      if (this.splitBy.includes(subCatalogId)) {
        this.splitBy = this.splitBy.filter((x) => x !== subCatalogId);
      } else {
        this.splitBy.push(subCatalogId);
      }
    },
  },
  created() {
    if (this.subscription) {
      this.groups = this.subscription.config.groups;
      this.hour = this.subscription.config.hour;
      this.reportName = this.subscription.config.name;
      this.splitBy = this.subscription.config.splitBy || [];
      this.emailScopeType = this.subscription.config.emailScopeType || 'day';
      this.productsInColumns = this.subscription.config.productsInColumns || false;
      this.reportType = this.subscription.type;
      this.dayOffset = this.subscription.config.dayOffset || 0;
      this.skipWeekend = this.subscription.config.skipWeekend || false;
      this.reportUnpaid = this.subscription.config.reportUnpaid;
      this.emailEnabled = !this.subscription.config.emailDisabled;
      this.emails = this.subscription.config.emails.join('\n');
    }
  },
};
</script>

<style lang="scss" scoped>
  .group-row {
    border-bottom: 1px solid #eee;
    padding-top: 5px;
    padding-bottom: 5px;
    cursor: pointer;

    &:hover {
      background-color: #efefef;
    }
  }

  .close-button {
    position: absolute;
  }

  .draggable {
    border: 1px solid transparent;
    border-radius: 10px;
    min-height: 50px;
    background-color: #f8f8f8;
    padding: 5px;
    margin-top: 5px;
    min-height: 200px;
    padding-bottom: 40px;
  }

  .column {
    padding: 0.3rem 0.6rem;
    width: 100%;
    border-radius: 10px;
    background-color: #fff;
    border: 2px solid #eee;
    margin-top: 6px;
    font-size: 1rem;
    line-height: 1.2;
    cursor: pointer;
    transition: border-color 300ms, margin-right 300ms;

    &:hover {
      border-color: #999;
    }
  }
</style>
